"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var enums_1 = require("../enums");

var utils_1 = require("../utils");

exports.evaluateNumberVariable = function (numberVariable, variableDictionary) {
  switch (numberVariable.type) {
    case enums_1.NumberVariableType.Constant:
      {
        return numberVariable.value;
      }

    case enums_1.NumberVariableType.Map:
      {
        var variable = variableDictionary[numberVariable.key];

        if (utils_1.hasValue(variable) && variable.type === enums_1.VariableValueType.Number) {
          return variable.value;
        } else {
          return utils_1.withDefault(numberVariable.defaultValue, 0);
        }
      }

    case enums_1.NumberVariableType.Add:
      {
        return numberVariable.variables.reduce(function (sum, nextVariable) {
          return sum + exports.evaluateNumberVariable(nextVariable, variableDictionary);
        }, 0);
      }
  }
};